export function isAdministrationPath(pathname) {
    return pathname === '/admin'
        || pathname.startsWith('/admin/')
        || /^\/project\/[^/]+\/admin(?:\/|$)/.test(pathname)
        || /^\/project\/[^/]+\/reporting-lab\/(?:tracking-quality|data-quality)(?:\/|$)/.test(pathname);
}

export function visibleProjectAlerts(pathname, alerts) {
    if (isAdministrationPath(pathname)) {
        return [];
    }

    return alerts.filter(Boolean);
}
